import { MileageUnit } from '../gql/generated/graphql';

const MILEAGE_UNIT_ABBREVIATIONS: Record<MileageUnit, string> = {
  [MileageUnit.Miles]: 'mi',
  [MileageUnit.Kilometers]: 'km',
};

export const mileageUnitAbbreviation = (unit?: MileageUnit | null): string =>
  MILEAGE_UNIT_ABBREVIATIONS[unit ?? MileageUnit.Miles];

const MILEAGE_FIELD_LABELS: Record<MileageUnit, string> = {
  [MileageUnit.Miles]: 'Mileage',
  [MileageUnit.Kilometers]: 'Kilometers',
};

export const mileageFieldLabel = (unit?: MileageUnit | null): string =>
  MILEAGE_FIELD_LABELS[unit ?? MileageUnit.Miles];

export const mileageInfoLabel = (unit?: MileageUnit | null): string =>
  unit === MileageUnit.Kilometers ? `Mileage (${mileageUnitAbbreviation(unit)})` : 'Mileage';
